var router = require('./services/router');
var helpers = require('./services/helpers');
var authorization  = require('./services/authorization');
var keyboardActions = require('./services/keyboardActions');

var Address = require('./components/Address');
var preloader = require('./components/preloader');
var messages = require('./components/messages');

var YourAddresses = function () {
    var self = this;

    var addresses_before_start_editing = {
        bill_to: null,
        shipping_to: null
    };

    this.missing_address = ko.observable(true);

    this.editable = ko.observable();
    
    this.bill_to = new Address(null, 'billing');
    this.shipping_to = new Address(null, 'shipping');

    this.focused = ko.observable('').extend({
        notify: 'always'
    });

    this.editable.subscribe(function (value) {
        self.bill_to.static(!Boolean(value));
        self.shipping_to.static(!Boolean(value));
    });

    this.clean = function () {
        self.bill_to.clean();
        self.shipping_to.clean();
    };

    this.fillAddresses = function (addresses) {
        self.missing_address(!addresses.bill_to.id || !addresses.shipping_to.id);
        self.bill_to.fill(addresses.bill_to);
        self.shipping_to.fill(addresses.shipping_to);
    };

    this.editAddresses = function () {
        addresses_before_start_editing.bill_to = self.bill_to.getData();
        addresses_before_start_editing.shipping_to = self.shipping_to.getData();

        self.editable(true);
    };
    this.saveAddresses = function () {
        function saveCallback(status, message, data) {
            if (!status) {
                messages.removeAllItems();
                messages.addItem(message);
                if (data) {
                    data.bill_to.static = false;
                    data.shipping_to.static = false;
                }

                helpers.focusSequence(message, function () {
                    self.focused('title');
                });
            } else {
                self.editable(false);
                messages.removeAllItems();
                addresses_before_start_editing.bill_to = null;
                addresses_before_start_editing.shipping_to = null;
            }

            if (data) {
                data.bill_to.skip_validation = self.bill_to.skip_validation();
                data.shipping_to.skip_validation = self.shipping_to.skip_validation();
                self.fillAddresses(data);
            }
        }

        self.api.save(saveCallback);
    };
    this.discardChanges = function () {
        self.fillAddresses(addresses_before_start_editing);
        self.editable(false);

        addresses_before_start_editing.bill_to = null;
        addresses_before_start_editing.shipping_to = null;
    };

    this.setShippingAsBilling = function () {
        if (!self.editable()) return;

        var bill_to_data = self.bill_to.getData();
        bill_to_data.static = false;
        self.shipping_to.fill(bill_to_data);
    };

    this.init = function (addresses) {
        self.fillAddresses(addresses);
    };

    this.api = {
        validate: function (addresses, callback) {

            callback({status: true});
        },
        save: function (callback) {
            preloader.show('your-address');
            $.ajax({
                url: 'rest.php/update_addresses',
                method: 'POST',
                data: {
                    bill_to: self.bill_to.getData(),
                    shipping_to: self.shipping_to.getData()
                },
                dataType: 'json',
                context: this
            }).done(function (resp) {
                callback(resp.status, resp.message, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('your-address');
            });
        }
    };

    this.onShow = function () {
        self.focused('title');
    };
    this.onHide = function () {
        self.focused('');
    };

    this.setShippingAsBillingKeyDonw = function (me, e) {
        if (!keyboardActions.isTab(e.keyCode)) return true;

        e.preventDefault();
        self.focused('discard-changes');
    }
};

module.exports = YourAddresses;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/YourAddressesPage.js
// module id = 28
// module chunks = 0